export default {
  stateKey: 'bulletList',
  order: 8,
  commandKey: 'toggleBulletList',
  icon: ['far', 'list-ul'],
  appearance: {
    menu: true,
    bubble: true,
  },
}
